import { add, endOfMonth, startOfToday } from 'date-fns';
import { useMemo, useState } from 'react';

import useCaseNavigateBookingWizard from 'application/modules/bookingWizard/useCases/hooks/useCaseNavigateBookingWizard';
import useCaseExternalNavigation from 'application/modules/bookingWizard/useCases/hooks/useCaseNavigateTo';
import { IGetSimulatorAvailabilityAdapter } from 'application/modules/bookingWizard/useCases/hooks/useCaseSelectSimulatorReservationDate';
import { WizardStep } from 'domain/entities/WizardStep';
import mboAPI from 'infrastructure/redux/adapters/mboAPI/mboApi';
import { selectLocation } from 'infrastructure/redux/slices/bookingWizard.selector';
import { setResourceId } from 'infrastructure/redux/slices/bookingWizard.slice';
import { useAppDispatch, useAppSelector } from 'infrastructure/redux/store/hooks';
const useGetSimulatorAvailability: IGetSimulatorAvailabilityAdapter = () => {
  const selectedLocationId = useAppSelector(selectLocation);
  const startDateTime = useMemo(() => startOfToday().toISOString(), []);
  const dispatch = useAppDispatch();

  const [endDateTime, setEndDateTime] = useState(
    endOfMonth(add(new Date(), { months: 1 })).toISOString(),
  );
  const { nextStep } = useCaseNavigateBookingWizard(WizardStep.reservationDate);
  const { navigateToEventsInquiryPage } = useCaseExternalNavigation();
  const {
    data: availableDatesMap,
    error,
    isLoading,
    isFetching,
  } = mboAPI.useGetAvailableSimulatorRentalDatesQuery(
    {
      locationId: selectedLocationId || '',
      startDateTime,
      endDateTime,
    },
    {
      skip: !selectedLocationId || !startDateTime || !endDateTime,
      refetchOnMountOrArgChange: true,
    },
  );
  const availableDates = useMemo(
    () => availableDatesMap?.map((date) => new Date(date)),
    [availableDatesMap],
  );

  const handleNextStep = (partySize: string) => {
    dispatch(setResourceId({ resourceId: undefined }));
    if (partySize === '13+') {
      navigateToEventsInquiryPage(selectedLocationId || '');
    } else {
      nextStep();
    }
  };

  const handleFetchFurtherAvailableDates = (newDate: Date | null) => {
    if (newDate) {
      setEndDateTime(endOfMonth(add(newDate, { months: 1 })).toISOString());
    }
  };

  return {
    inProgress: isLoading || isFetching,
    error,
    result: availableDates,
    fetchFurtherAvailableDates: handleFetchFurtherAvailableDates,
    nextStep: handleNextStep,
  };
};

export default useGetSimulatorAvailability;
